import { removeOffers } from './removeOffers';
import { setPage } from './setPage';
import { resetTerms } from '../../../../packages/JsonQuery';
import { TThunkAction } from '../../types/redux';
import { justChangeJsonQuery } from '../filters/justChangeJsonQuery';

export const resetListingOffers = (): TThunkAction => (dispatch, getState) => {
  const { jsonQuery } = getState().results;
  const nextJsonQuery = resetTerms(['page'])(jsonQuery);

  dispatch(removeOffers());
  dispatch(justChangeJsonQuery({ nextJsonQuery }));
  dispatch(setPage(1));
};
